import React from 'react';
import superagent from 'superagent';

import styles from '../kalendar/Home.css';

import { LoggedUserAdmin, LoggedUserId } from '../login/Login';

export default class Statistiky extends React.Component {

  constructor() {
    super();
    this.state = {
      datum: new Date(),
      stats: null,
      actLekce: null,
    };

    this.handleIncMonth = this.handleIncMonth.bind(this);
    this.handleDecMonth = this.handleDecMonth.bind(this);
    this.loadLekce = this.loadLekce.bind(this);
  }

  componentWillMount = () => {
    this.loadLekce();
  }

  loadLekce() {
    var obdobi = this.state.datum.getFullYear() + '-' + ("0" + (this.state.datum.getMonth() + 1)).slice(-2);
    var responseObj = superagent.get('https://rezervace.copasedeje.cz/servis/_lekce_stats.php?userid=' + LoggedUserId() + '&obdobi=' + obdobi + '&t=' + Date()).set('Content-Type', 'application/json').then(response => {
      var myObject = JSON.parse(response.text);
      this.setState({stats: myObject});
    });
  }

  handleIncMonth() {
    var newDate = new Date(this.state.datum.getFullYear(), this.state.datum.getMonth()+1, 1)
    this.setState({datum: newDate, stats: null}, this.loadLekce);
  }

  handleDecMonth() {
    var newDate = new Date(this.state.datum.getFullYear(), this.state.datum.getMonth()-1, 1);
    this.setState({datum: newDate, stats: null}, this.loadLekce);
  }

  render() {
    if (!LoggedUserAdmin) {
      return null;
    }

    var months = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
    var d = this.state.datum;

    if (this.state.stats == null) {
      return (
        <div className={styles.root}>
          <h1 className={styles.panelHeader}>Seznam lekcí <button type="button" className="btn btn-success float-right mt-2">+</button></h1>
          <div className={"table-responsive " + styles.tablePanel}>
            <h3 className="text-uppercase text-center mb-2">
              <a onClick={this.handleDecMonth} className={"float-left " + styles.pointer}>&lt;</a>
              {months[d.getMonth()] + ' ' + d.getFullYear()}
              <a onClick={this.handleIncMonth} className={"float-right " + styles.pointer}>&gt;</a>
            </h3>
            <div className="text-center"><img src="https://rezervace.copasedeje.cz/servis/images/loading-line.gif" className="loading" /></div>
          </div>
        </div>
      )
    }

    /*var items = this.state.lekce.map(function(item, index) {
      return (
        <tr key={item.id} className={(item.aktivni == 'A' ? '' : 'lekce_zrusena')}>
          <td className="text-left cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.datum}<div className="d-sm-none d-table-cell poznamka">{item.cas_od}-{item.cas_do}</div></td>
          <td className="text-left d-none d-sm-table-cell cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.cas_od}-{item.cas_do}</td>
          <td className="text-left cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.nazev}</td>
          <td className="text-left d-none d-sm-table-cell cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.lektor}</td>
          <td className="text-center cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.pocet}/{item.kapacita}</td>
          <td className="text-center cursor-pointer" data-id={item.id} onClick={this.editLekce}>{item.aktivni}</td>
        </tr>
      )
    }.bind(this));*/

    var por = 0;
    var tabs = this.state.stats.map((tab) => {
      if (por == 0) {
        var selected = "true";
        var active = "active";
      } else {
        var selected = "false";
        var active = ""
      }
      por++;
      return (
        <li className="nav-item" key={por}>
          <a className={"nav-link "+active} id={"tab-" + tab.odkaz} data-toggle="tab" href={"#"+tab.odkaz} role="tab" aria-controls={tab.odkaz} aria-selected={selected}>{tab.jmeno}</a>
        </li>
      )
    });

    var por = 0;
    var tabDiv = this.state.stats.map((tab) => {
      if (por == 0) {
        var selected = "active";
      } else {
        var selected = "";
      }
      por++;
      var celkem = 0;
      var pocet = 0;
      var lekce = tab.lekce.map((item) => {
        celkem += 1*item.pocet;
        pocet ++;
        return (
          <tr key={item.id} className={(item.aktivni == 'A' ? '' : 'lekce_zrusena')}>
            <td className="text-left">{item.datum}<div className="d-sm-none d-table-cell poznamka">{item.cas_od}-{item.cas_do}</div></td>
            <td className="text-left d-none d-sm-table-cell">{item.cas_od}-{item.cas_do}</td>
            <td className="text-left">{item.nazev}</td>
            <td className="text-center">{item.pocet}</td>
            <td className="text-center">{item.aktivni}</td>
          </tr>
        )
      });

      return (
        <div className={"tab-pane fade show "+selected} key={por} id={tab.odkaz} role="tabpanel" aria-labelledby={"tab-"+tab.jmeno}>
          <table id="table_lekce" className={"table table-striped table-hover"}>
            <thead>
              <tr>
                <th>Datum</th>
                <th className="text-left d-none d-sm-table-cell">Čas</th>
                <th>Název</th>
                <th className="text-center">Obsazeno</th>
                <th className="text-center">Aktivní</th>
              </tr>
            </thead>
            <tbody>
              {lekce}
            </tbody>
            <tfoot>
            <tr>
              <th>CELKEM</th>
              <th className="text-left d-none d-sm-table-cell"></th>
              <th></th>
              <th className="text-center">{celkem} osob</th>
              <th className="text-center">{pocet} lekcí</th>
            </tr>
            </tfoot>
          </table>
        </div>
      )
    });

    return (
      <div className={styles.root}>
        <h1 className={styles.panelHeader}>Seznam lekcí <button type="button" className="btn btn-success float-right mt-2" onClick={this.addLekci}>+</button></h1>
        <div className={"table-responsive shadow " + styles.tablePanel}>
          <h3 className="text-uppercase text-center mb-2">
            <a onClick={this.handleDecMonth} className={"float-left " + styles.pointer}>&lt;</a>
            {months[d.getMonth()] + ' ' + d.getFullYear()}
            <a onClick={this.handleIncMonth} className={"float-right " + styles.pointer}>&gt;</a>
          </h3>

          <ul className="nav nav-tabs mb-3" id="myTab" role="tablist">
            {tabs}
          </ul>
          <div className="tab-content" id="myTabContent">
            {tabDiv}
          </div>

        </div>
      </div>
    );
  }


}



// WEBPACK FOOTER //
// src/components/statistiky/Statistiky.js